// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__143Z4","footer":"ModalInfo_footer__2oyFn"};